<template>
    <footer class="layout__footer">

        <!-- Footer copy -->
        <div class="layout__footer_copy-block">
<!--            <a href="#" class="layout__footer_logo">
                <img
                    src="https://minio.cdnwv.com/lk.neologistics.it/svg/footer-logo.svg"
                    alt="Neologistics logo"/>
            </a>
            <p class="layout__footer_copy layout__footer_copy-year">
                Neo Logistics SRL © 2017 — {{ (new Date).getFullYear() }}
            </p>
            <p class="layout__footer_copy">
                <span>65020 Via Silvio di Gregorio, 20 Bolognano (PE), Italia</span>
            </p>-->

<!--            <a
                target="_blank"
                :href="termsOfWorkLink"
                class="layout__footer_terms">
                Terms of work
            </a>-->
        </div>

    </footer>
</template>

<script>
module.exports = {
    name: 'Footer',
    props: [],
    data() {
        return {};
    },
    computed: {
        menuElements() {
            return this.$store.state.menu;
        },
        termsOfWorkLink() {
            return document.location.pathname.split('/')[1] === 'ru'
                ? '/terms/terms-ru.pdf'
                : '/terms/terms-en.pdf'
        },
    },
    methods: {
        getElementPath(element) {
            if (typeof element.path === 'function') {
                return element.path()
            } else {
                return element.path
            }
        },
        goToRoute(element) {
            if (this.getElementPath(element) !== '#') {
                if (element.external) {
                    window.open(this.getElementPath(element), '_blank').focus()
                } else {
                    this.$router.push(element.path)
                }
            }
        },
    },
    beforeMount() {
    }
};
</script>

<style lang="scss">
@import '../../scss/utils/mixins.scss';
@import '../../scss/utils/variables.scss';

.layout__footer {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 60px;
    margin-top: auto;
    position: relative;
    justify-content: center;
    @include break(md) {
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: row;
    }
    a {
        transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
    }
    a:hover {
        color: $color-day-black;
    }
    &_logo {
        margin-bottom: 30px;
        img{
            height: 50px;
        }
    }

    &_copy-block {
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        margin-right: auto;
        @include maxWidth(720) {
            margin-right: 0;
            align-items: center;
        }
    }

    &_copy,
    &_terms {
        margin-bottom: 15px;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: $color-day-gray;
        font-family: $font-primary;
        @include maxWidth(720) {
            text-align: center;
            margin-bottom: 0;
        }

        span {
            display: block;
            text-transform: capitalize;
        }
    }

    &_copy-year {
        @include maxWidth(720) {
            margin-bottom: 15px;
        }
    }

    &_terms {
        display: block;
        margin-top: 40px;
        margin-bottom: 0;
        text-transform: inherit;

        @include maxWidth(720) {
            margin-top: 15px;
        }
    }

    &_navigation {
        height: 100%;
        display: flex;
        flex-direction: column;
        @include break(md) {
            width: calc(100% - 300px);
        }
        @include break(xl) {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
        }
    }

    &_menu {
        width: 100%;
        flex: none;
        display: flex;
        flex-direction: row;
        //flex-flow: column wrap;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: flex-start;
        padding-top: 15px;
        padding-bottom: 30px;
        &-block {
            width: 100%;
            display: none;
            @include break(sm) {
                display: flex;
                flex-direction: column;
            }
        }
        &-title {
            height: 40px;
            display: flex;
            width: 100%;
            flex: none;
            justify-content: flex-start;
            align-items: flex-start;
            border-bottom: 1px solid $color-day-line;
            font-family: $font-secondary;
            font-weight: bold;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 0.02em;
            color: $color-day-dark-gray;
        }
        &-item {
            width: 50%;
            flex: none;
            height: 30px;
            font-family: $font-secondary;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            letter-spacing: 0.02em;
            color: $color-day-dark-gray;
            @include break(sm) {
                width: 25%;
            }
            @include break(md) {
                width: 33%;
            }
        }
    }
}
</style>
